export default "__VITE_ASSET__a7717cc8__"